import React from 'react';
import Framework7 from 'framework7/framework7.esm.bundle.js';
import Framework7React, { App, Statusbar, View } from 'framework7-react';
import 'framework7/css/framework7.min.css';
import './style.css';
import './transitions.css';
import routes from './routes.js';

Framework7.use(Framework7React);

const f7params = {
  routes,
  name: 'lyriXpert',
  id: 'lyrixpert',
  theme: 'ios'
};

export default () => (
  <App params={f7params}>
    <Statusbar />
    <View main url="/" />
  </App>
);


// WEBPACK FOOTER //
// ./src/app.js